import { render, staticRenderFns } from "./TariffRadioGroup.vue?vue&type=template&id=a4786d7c&scoped=true"
import script from "./TariffRadioGroup.vue?vue&type=script&lang=ts"
export * from "./TariffRadioGroup.vue?vue&type=script&lang=ts"
import style0 from "./TariffRadioGroup.vue?vue&type=style&index=0&id=a4786d7c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4786d7c",
  null
  
)

export default component.exports